import React, { useState, useMemo, useEffect, useCallback } from "react";
import {
  Card,
  Container,
  CardBody,
  CardHeader,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import { getId, getRole } from "../../utils/helpers/custom";
import TableContainer from "../../components/common/tableContainer";
import Loader from "../../components/common/loader";
import { Link, useNavigate } from "react-router-dom";
import NoResultsMessage from "../../components/noResultMessage";
import ApproveRejectModal from "../../components/common/approveRejectModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  deleteProject,
  listOfAssignProject,
  listOfProject,
} from "../../api/itpProject";
import { toast } from "react-toastify";
import SimpleBar from "simplebar-react";
import { checkStatusCodeSuccess, CommonLabel, Roles } from "../../utils/helpers/common";
import { ItpLabel } from "../../common/constant/Itp";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseModal from "../../components/BaseComponents/BaseModal";

const ITPProject = (props) => {
  document.title = ItpLabel.ItpProject;
  const navigate = useNavigate();
  const role = getRole();
  const id = getId();
  const [loading, setLoading] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [selectedAssignRow, setSelectedAssignRow] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState();
  const [modalTodo, setModalTodo] = useState(false);

  const listOfProjectFun = () => {
    setIsLoading(true);
    listOfProject()
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setSelectedRow(res?.data);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setIsLoading(false);
      });
  };

  function projectDetails(id) {
    setLoading(true);
    listOfProject({
      itpProjectId: id,
    })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setProjectData(res?.data);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  }

  const listOfEmployeeAssignProject = () => {
    setTableLoader(true);
    listOfAssignProject({
      assignTo: +id,
    })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setSelectedAssignRow(res?.data);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setTableLoader(false);
      });
  };

  useEffect(() => {
    if (role === Roles.Employee) {
      listOfEmployeeAssignProject();
    } else {
      listOfProjectFun();
    }
  }, []);

  const QueryColumns = useMemo(() => [
    {
      Header: ItpLabel.ProjectName,
      accessor: "projectName",
      filterable: false,
    },
    {
      Header: ItpLabel.Day,
      accessor: "totalDays",
      filterable: false,
    },
    {
      Header: ItpLabel.Api,
      accessor: "totalApis",
      filterable: false,
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        let isEnable =
          cellProps?.cell?.row?.original?.itpProjectDetails?.length <= 0;
        return (
          <div>
            <div className="hstack gap-2">
              {/* Edit */}
              {(role !== Roles.Employee || role !== Roles.BDE) && (
                <>
                <Link
                  id={`editMode-${cellProps?.cell?.row?.index}`}
                  className="btn btn-sm btn-soft-info remove-list"
                  to={`/itp-project/create/${cellProps?.cell?.row?.original?.id}`}
                >
                  <i className="ri-pencil-fill align-bottom" />
                </Link>
                  <ReactTooltip
                    place="bottom"
                    variant="info"
                    content={CommonLabel.Update}
                    anchorId={`editMode-${cellProps?.cell?.row?.index}`}
                  />
                </>
              )}
              {/* Delete */}
              {(role !== Roles.Employee || role !== Roles.BDE) && (
                <>
                <Link
                  id={`deleteTodo-${cellProps?.cell?.row?.index}`}
                  className="btn btn-sm btn-soft-danger remove-list"
                  onClick={() =>
                    handleDelete(cellProps?.cell?.row?.original?.id)
                  }
                >
                  <i className="ri-delete-bin-5-fill align-bottom" />
                </Link>
                <ReactTooltip
                  place="bottom"
                  variant="error"
                  content={CommonLabel.Delete}
                  anchorId={`deleteTodo-${cellProps?.cell?.row?.index}`}
                />
                </>
              )}
              {isEnable ? (
                <>
                <Link
                  id={`viewMode-${cellProps?.cell?.row?.index}`}
                  className="btn btn-sm btn-soft-info remove-list"
                  disabled
                  to="/itp-project/modules"
                  state={{ id: cellProps?.cell?.row?.original?.id }}
                >
                  <i className="ri-eye-line align-bottom" />
                </Link>
                  <ReactTooltip
                    place="bottom"
                    variant="info"
                    content={ItpLabel.ViewModules}
                    anchorId={`viewMode-${cellProps?.cell?.row?.index}`}
                  />
                </>
              ) : (
                  <>
                <Link
                  id={`viewMode-${cellProps?.cell?.row?.index}`}
                  className="btn btn-sm btn-soft-info remove-list"
                  to="/itp-project/modules"
                  state={{ id: cellProps?.cell?.row?.original?.id }}
                >
                  <i className="ri-eye-line align-bottom" />
                </Link>
                  <ReactTooltip
                    place="bottom"
                    variant="info"
                    content={ItpLabel.ViewModules}
                    anchorId={`viewMode-${cellProps?.cell?.row?.index}`}
                  />
                  </>
              )}
              <Link
                id={`viewDetails-${cellProps?.cell?.row?.original?.id}`}
                className="btn btn-sm btn-soft-success remove-list"
                onClick={() => {
                  toggle();
                  projectDetails(cellProps?.cell?.row?.original?.id);
                }}
              >
                <i className="ri-booklet-line align-bottom" />
              </Link>
                <ReactTooltip
                  place="bottom"
                  variant="success"
                  content={ItpLabel.ProjectDetails}
                  anchorId={`viewDetails-${cellProps?.cell?.row?.original?.id}`}
                />
            </div>
          </div>
        );
      },
    },
  ]);

  const EmployeeQueryColumns = useMemo(() => [
    {
      Header: ItpLabel.ProjectName,
      accessor: "itpProject.projectName",
      filterable: false,
    },
    {
      Header: ItpLabel.Day,
      accessor: "itpProject.totalDays",
      filterable: false,
    },
    {
      Header: ItpLabel.Api,
      accessor: "itpProject.totalApis",
      filterable: false,
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            <div className="hstack gap-2">
              <Link
                id={`viewMode-${cellProps?.cell?.row?.index}`}
                className="btn btn-sm btn-soft-info remove-list"
                to="/itp-project/modules"
                state={{ id: cellProps?.cell?.row?.original?.itpProject?.id }}
              >
                <i className="ri-eye-line align-bottom" />
                <ReactTooltip
                  place="bottom"
                  variant="info"
                  content={CommonLabel.View}
                  anchorId={`viewMode-${cellProps?.cell?.row?.index}`}
                />
              </Link>
              <Link
                id={`viewDetails-${cellProps?.cell?.row?.original?.id}`}
                className="btn btn-sm btn-soft-success remove-list"
                onClick={() => {
                  toggle();
                  projectDetails(cellProps?.cell?.row?.original?.id);
                }}
              >
                <i className="ri-booklet-line align-bottom" />
                <ReactTooltip
                  place="bottom"
                  variant="success"
                  content={ItpLabel.ProjectDetails}
                  anchorId={`viewDetails-${cellProps?.cell?.row?.original?.id}`}
                />
              </Link>
            </div>
          </div>
        );
      },
    },
  ]);

  // Delete
  const handleDelete = (id) => {
    setSelectedDeleteId(id);
    setDeleteModal(true);
  };

  const handleDeleteTodo = () => {
    setLoading(true);
    deleteProject({ id: selectedDeleteId })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.data?.statusCode)) {
          toast.success(res?.data?.message);
          listOfProjectFun();
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setDeleteModal(false);
        setLoading(false);
        listOfProjectFun();
      });
  };

  const toggle = useCallback(() => {
    if (modalTodo) {
      setModalTodo(false);
    } else {
      setModalTodo(true);
    }
  }, [modalTodo]);

  function HtmlToJsx(htmlString) {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  }

  return (
    <React.Fragment>
      <ApproveRejectModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
        action={selectedRow ? selectedRow.action : ""}
        loader={loading}
      />
      <div className="page-content">
          <Container fluid>
            <BreadCrumb title={ItpLabel.ItpProject} pageTitle={ItpLabel.Itp} navigation="/itp" />
            <Row className="mb-2">
              <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                <h5 className="fw-semibold mt-2">
                  {ItpLabel.ItpFullForm}{" "}{ItpLabel.Project}
                </h5>
              </div>

              <div className="col-auto order-2 order-sm-3 ms-auto">
                <div className="hstack gap-2">
                  {role !== Roles.Employee && (
                    <Link to="/itp-project/create">
                      <BaseButton
                        color="primary"
                        type="button">
                          <i className="ri-add-line mt-2" />
                          {ItpLabel.NewProject}
                      </BaseButton>
                    </Link>
                  )}
                </div>
              </div>
            </Row>
            <Card>
              <CardHeader className="align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">{ItpLabel.ItpProject}</h4>
              </CardHeader>

              <CardBody>
                {role !== Roles.Employee && role !== Roles.BDE ? (
                  <>
                    {(selectedRow?.length || isLoading) ? (
                      <TableContainer
                        columns={QueryColumns}
                        data={selectedRow || []}
                        isAddUserList={false}
                        customPageSize={5}
                        isGlobalFilter={true}
                        tableLoader={isLoading}
                        divClass="table-responsive table-card mb-1 "
                        tableClass="align-middle table-nowrap "
                        theadClass="table-light text-muted"
                        SearchPlaceholder={CommonLabel.Search}
                      />
                    ) : (
                      <NoResultsMessage />
                    )}
                  </>
                ) : (
                  <>
                    {(selectedAssignRow?.length || tableLoader) ? (
                      <TableContainer
                        columns={EmployeeQueryColumns}
                        data={selectedAssignRow || []}
                        isAddUserList={false}
                        customPageSize={5}
                        isGlobalFilter={true}
                        tableLoader={tableLoader}
                        divClass="table-responsive table-card mb-1"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light text-muted"
                        SearchPlaceholder={CommonLabel.Search}
                      />
                    ) : (
                      <NoResultsMessage />
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </Container>
      </div>

      <BaseModal
        open={modalTodo}
        size="xl"
        onClose={() => setModalTodo(false)}
        toggle={toggle}
        className="zoomIn"
        title={ItpLabel.ProjectDetails}
        bodyClassName="p-4"
        closeLabel={CommonLabel.Close}
        closeLabelColor="ghost-success"
      >
        <div id="task-error-msg" className="alert alert-danger py-2"></div>

        <Card>
          <CardBody>
            <div className="mx-n3">
              <SimpleBar
                autoHide={false}
                style={{ maxHeight: "220px" }}
                className="px-3"
              >
                <div>
                  <div>
                    <strong>{ItpLabel.ProjectName}</strong> : {projectData[0]?.projectName}
                  </div>
                  <div>
                    <strong>{ItpLabel.TotalDays}</strong> : {projectData[0]?.totalDays}
                  </div>
                  <div>
                    <strong>{ItpLabel.TotalApis}</strong> : {projectData[0]?.totalApis}
                  </div>
                  {HtmlToJsx(projectData[0]?.remark)}
                </div>
              </SimpleBar>
            </div>
          </CardBody>
        </Card>
      </BaseModal>
    </React.Fragment>
  );
};

export default ITPProject;
